import React from "react";
import { useTranslation } from "react-i18next";

type Props = {};

const ContractDocumentHeader = (props: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  return (
    <div className="d-none d-sm-block px-3 mb-2 text-muted font-weight-bold mr-5">
      <div className="row no-gutters">
        <div className="col-sm-6">
          <div className="row no-gutters align-items-center">
            <div className="col-auto col-sm-6">{tLabels("contractDocumentHeader.documentType")}</div>
            <div className="col-auto col-sm-6 text-center">{tLabels("contractDocumentHeader.date")}</div>
          </div>
        </div>
        <div className="col-sm-6 text-truncate text-muted">{tLabels("contractDocumentHeader.name")}</div>
      </div>
    </div>
  );
};

export default ContractDocumentHeader;
